import { DEFAULT_BUSINESS_HOURS } from '../../lib/leadBot/businessHours';
import { DEFAULT_RUNAWAY_CAPS } from '../../lib/leadBot/runaway';
import { defaultVerticalForIndustry } from '../../lib/leadBot/verticalLayout';
import type { BotConfigArgs } from './api';

// A NEW BOT'S STARTING VALUES, for the one-click "Create bot for <club>" (the Services step). The same defaults the Bot form opens with,
// so the two ways of creating a bot make the same bot. ⚠️ The server starts every new bot in "Setting up" in draft mode, so creating
// one sends nothing to anyone and the AI SMS switch can be turned on safely straight afterwards. A fitness club (by its industry) gets a
// fitness bot; anything else gets the automotive default, as the form does. Pure.

export function defaultNewBotArgs(input: { accountId: string; accountName: string; industry: string | null }): BotConfigArgs {
  const fitness = defaultVerticalForIndustry(input.industry) === 'fitness';
  return {
    accountId: input.accountId,
    name: `${input.accountName} lead bot`,
    mode: 'draft',
    isActive: true,
    assistantName: '',
    goal: 'book a call or a visit with the sales team',
    tone: '',
    businessHours: DEFAULT_BUSINESS_HOURS,
    testPhoneAllowlist: [],
    knowledgeSupplement: '',
    forwardingNumber: null,
    handoffContactName: null,
    handoffPhone: null,
    handoffEmail: null,
    caps: { ...DEFAULT_RUNAWAY_CAPS },
    maxTurnsWithoutProgress: 6,
    ...(fitness ? { vertical: 'fitness' as const, playbook: 'new_lead_engagement' as const } : {}),
  };
}
